import { Reveal } from "@/components/bits";

const AUTHORS = [
  {
    slug: "enriquez",
    num: "01",
    name: "Mariana Enríquez",
    years: "1973 — presente",
    epithet: "Reina del gótico argentino",
    quote: "La función del miedo siempre es la misma: ensayar en la seguridad de la ficción los miedos de la vida real.",
    context: "Entrevista · Rosario3, 2023",
    text: "Carlos Pardo escribió en Babelia que su prosa es “condensada, de frialdad sugerente y apoyada en la contundencia del idioma”. Su literatura habita los bordes, donde lo cotidiano se tuerce, se oscurece e inquieta.",
    img: "/images/enriquez.jpg",
    bw: false,
  },
  {
    slug: "pizarnik",
    num: "02",
    name: "Alejandra Pizarnik",
    years: "1936 — 1972",
    epithet: "Poeta del abismo",
    quote: "¿Por qué escribo? Para asombrarme, yo, que nada sé de las palabras.",
    context: "Diarios · Lumen",
    text: "Cristina Piña, investigadora del CONICET, describe su escritura como un trabajo obsesivo del lenguaje: sus diarios fueron un laboratorio donde una voz se corregía sin tregua.",
    img: "https://customer-assets.emergentagent.com/job_critica-argentina/artifacts/mlb4c9vw_pizarnik.avif",
    bw: false,
  },
  {
    slug: "gallardo",
    num: "03",
    name: "Sara Gallardo",
    years: "1931 — 1988",
    epithet: "La voz pampeana",
    quote: "Escribir es un oficio absurdo y heroico.",
    context: null,
    text: "De Enero a El país del humo: una escritura áspera, telúrica, política. Una de las voces más singulares y menos leídas de la literatura argentina.",
    img: "/images/gallardo.jpg",
    bw: false,
  },
  {
    slug: "cabezon-camara",
    num: "04",
    name: "Gabriela Cabezón Cámara",
    years: "1968 — presente",
    epithet: "La desobediencia del canon",
    quote: "Escribir es construir un lugar habitable en el mundo.",
    context: "Entrevista · Revista El Diletante",
    text: "La virgen cabeza, su primera novela: una comuna en los márgenes de la ciudad. Cabezón Cámara escribe desde el deseo, el cuerpo y la lengua: la literatura como desobediencia.",
    img: "/images/cabezon-camara.jpg",
    bw: true,
  },
];

export default function Autoras() {
  return (
    <section id="autoras" data-testid="autoras-section" className="bg-ink py-20 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="flex items-center gap-4 text-[11px] font-medium uppercase tracking-[0.3em] text-gold">
            <span className="h-px w-10 bg-gold/60" /> Las cuatro
          </p>
          <h2 className="mt-8 font-serif text-3xl leading-[1.12] tracking-tight text-cream sm:text-4xl lg:text-5xl">
            Cuatro autoras, <span className="font-semibold not-italic text-gold">diferentes voces.</span>
          </h2>
          <p className="mt-4 font-serif text-xl italic leading-snug text-bone/85 sm:text-2xl">
            Y una misma literatura nacional, transformada&nbsp;&nbsp;&nbsp;
            <span className="not-italic tracking-[0.35em] text-gold">c&nbsp;a&nbsp;d&nbsp;a&nbsp;&nbsp;v&nbsp;e&nbsp;z</span>.
          </p>
          <p className="mt-6 max-w-xl text-sm font-light leading-relaxed text-ash sm:text-base">
            Cuatro escritoras, cuatro mundos. Cuatro maneras de torcer el lenguaje.
          </p>
        </Reveal>

        <div className="mt-10">
          {AUTHORS.map((a, i) => (
            <Reveal key={a.slug}>
              <article
                data-testid={`author-card-${a.slug}`}
                className="grid grid-cols-1 items-center gap-10 border-t border-cream/10 py-14 lg:grid-cols-2 lg:gap-16"
              >
                <div className={i % 2 === 1 ? "lg:order-2" : ""}>
                  <img
                    src={a.img}
                    alt={a.name}
                    loading="lazy"
                    className={`aspect-[4/3] w-full object-cover object-top ${a.bw ? "grayscale contrast-105" : ""}`}
                  />
                </div>
                <div className={i % 2 === 1 ? "lg:order-1" : ""}>
                  <div className="flex items-baseline gap-5">
                    <span className="font-serif text-5xl text-gold/60">{a.num}</span>
                    <div>
                      <p className="text-[10px] font-medium uppercase tracking-[0.3em] text-ash">{a.epithet}</p>
                      <h3 className="mt-2 font-serif text-2xl tracking-tight text-cream sm:text-3xl">{a.name}</h3>
                      <p className="mt-1 text-[10px] uppercase tracking-[0.25em] text-ash">{a.years}</p>
                    </div>
                  </div>
                  <div className="mt-8 border-l-2 border-crimson-light pl-5">
                    <blockquote className="font-serif text-lg italic leading-relaxed text-bone">
                      “{a.quote}”
                    </blockquote>
                    {a.context && (
                      <p className="mt-3 text-[10px] font-medium uppercase tracking-[0.22em] text-ash/70">
                        {a.context}
                      </p>
                    )}
                  </div>
                  <p className="mt-6 max-w-lg text-base font-light leading-relaxed text-ash/90">{a.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
